import { show_layout_modal, setupAjaxCursor } from '../vpsb/global';

class VpsInstances {
  init() {
    this.setup_test_connection();
    this.radio_divs_click_handler();
  }

  radio_divs_click_handler() {
    $('#vps_instance_choice_plan_name_div').on('click', (event) => {
      console.log("click on vps_instance_plan_name");
      $('input:radio#vps_instance_choice_plan_name').prop('checked', true);
    });

    $('#vps_instance_choice_plan_select_div').on('click', (event) => {
      console.log("click on vps_instance_plan_select");
      $('input:radio#vps_instance_choice_plan_select').prop('checked', true);
    });

    $('#vps_instance_choice_auth_password_div').on('click', (event) => {
      console.log("click on vps_instance_auth_password");
      $('input:radio#vps_instance_choice_auth_password').prop('checked', true);
    });

    $('#vps_instance_choice_auth_sshkey_div').on('click', (event) => {
      console.log("click on vps_instance_auth_sshkey");
      $('input:radio#vps_instance_choice_auth_sshkey').prop('checked', true);
    });
  }

  setup_test_connection() {
    var form = $('#new_vps_instance');
    var meta = $('meta[name=csrf-token]');
    var csrfToken = meta.attr('content');
    $('#test-connection-btn').on('click', (event) => {
      event.preventDefault();
      $.ajax({
        method: "POST",
        url: "/vps_instances/test_connection",
        data: form.serialize(),
        dataType: 'json',
        headers: { "X-CSRF-Token": csrfToken },
        success: function(data) {
          show_layout_modal(data.data);
        },
        error: function(data, textStatus, xhr) {
          var respBody = data.responseJSON;
          console.log(`err: ${respBody.error}, code: ${data.status}`);
          show_layout_modal(respBody.data);
        }
      });
    })
  }
}

$(document).on('turbo:render', function() {
  // For handling 422
  if ($("body.vps_instances.create").length == 0) {
    return;
  }
  console.log("page render in vps_instances.js");


  var vps_instances = new VpsInstances();
  vps_instances.init();

  setupAjaxCursor();
});

$(document).on('turbo:load', function() {
  if ($("body.vps_instances.new").length == 0) {
    return;
  }
  console.log("page load in vps_instances.js");


  var vps_instances = new VpsInstances();
  vps_instances.init();

  setupAjaxCursor();
});
